import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { event } from '@uhg-abyss/web/tools/event';
// import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { saveAs } from 'file-saver';

const NavItem = styled('div', {
  padding: '28px 0px 0px 0px',
});

const StyledNavLink = styled('div', {
  display: 'block',
  color: '#196ECF',
  textDecoration: 'none',
  marginBottom: '0',
});
const Heading = styled('div', {
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '24px',
  letterSpacing: '0px',
  textAlign: 'left',
  color: '#424242',
  textTransform: 'uppercase',
});

const LinkText = styled('a', {
  display: 'flex',
  padding: '4px 0px 4px 0px',
  fontSize: '15px',
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  width: 'fit-content',

  '&:hover': {
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

const LinkTextBold = styled('p', {
  display: 'flex',
  padding: '4px 0px 4px 0px',
  fontSize: '15px',
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  width: 'fit-content',
  marginBottom: 0,
  fontWeight: 'bold',
  textTransform: 'capitalize',
});

const BottomMargin = styled('div', {
  marginBottom: '16px',
});

const DownloadDiv = styled('div', {
  paddingRight: '10px',
  textTransform: 'capitalize',
});

export const LeftNavLink = ({ data, loading, ...props }) => {
  const { navigate } = useRouter();

  // Sort pathsByTag and ensure "Overview & Onboarding" is first
  const sortedPathsByTag = React.useMemo(() => {
    if (!data.pathsByTag) return [];

    // Function to determine path priority (for ordering)
    const getPathPriority = (pathName) => {
      const priorities = {
        overview: 1,
        'frequently asked questions': 2,
        'technical demo videos': 3,
        'technical documentation': 4,
        // Default priority for other paths
        default: 100,
      };

      // Find matching priority or use default
      const matchingKey = Object.keys(priorities).find((key) => {
        return pathName.toLowerCase().includes(key);
      });
      return matchingKey ? priorities[matchingKey] : priorities.default;
    };

    return [...data.pathsByTag]
      .sort((a, b) => {
        // Always put "Overview & Onboarding" first
        if (a.tag === 'Overview & Onboarding') return -1;
        if (b.tag === 'Overview & Onboarding') return 1;

        // Otherwise sort alphabetically
        return a.tag.localeCompare(b.tag);
      })
      .map((tagGroup) => {
        // If it's "Overview & Onboarding", don't sort the paths
        if (tagGroup.tag === 'Overview & Onboarding') {
          return tagGroup;
        }

        // want to make here tagGroup.tag to camelcase

        // For all other tags, sort the paths according to priority
        return {
          ...tagGroup,

          paths: [...tagGroup.paths].sort((a, b) => {
            const priorityA = getPathPriority(a.name);
            const priorityB = getPathPriority(b.name);

            if (priorityA !== priorityB) {
              return priorityA - priorityB;
            }

            // If same priority, sort alphabetically
            return a.name.localeCompare(b.name);
          }),
        };
      });
  }, [data.pathsByTag]);

  const linkClick = (tag, path) => {
    const interactionName = path.name.includes('Release Notes')
      ? 'Release Notes'
      : tag;
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue: path.name,
      interactionContext: 'left navigation link click',
    });
    if (path.id.includes('download')) {
      saveAs(path.path);
    } else {
      navigate(path.path);
      // props.handleSideNav(path.path);
    }
  };

  return (
    <NavItem>
      {loading ? (
        <LoadingSpinner isLoading={loading} />
      ) : (
        sortedPathsByTag.length > 0 && (
          <React.Fragment>
            {sortedPathsByTag.map((tag) => {
              return (
                <React.Fragment key={tag.tag}>
                  <Heading>{tag.tag}</Heading>
                  <BottomMargin>
                    {tag.paths.map((path) => {
                      return (
                        <StyledNavLink key={path.id}>
                          {window.location.href.split('/').pop() === path.id ? (
                            <LinkTextBold>{path.name}</LinkTextBold>
                          ) : (
                            <LinkText
                              onClick={() => {
                                return linkClick(tag.tag, path);
                              }}
                            >
                              <DownloadDiv>{path.name}</DownloadDiv>
                              {/* {path.id.includes('download') && (
                        <DownloadDiv>
                          <IconSymbol
                            icon="download"
                            size="16px"
                            css={{
                              'abyss-icon-material': {
                                verticalAlign: 'middle',
                              },
                            }}
                          />
                        </DownloadDiv>
                      )} */}
                            </LinkText>
                          )}
                        </StyledNavLink>
                      );
                    })}
                  </BottomMargin>
                </React.Fragment>
              );
            })}
          </React.Fragment>
        )
      )}
    </NavItem>
  );
};

LeftNavLink.propTypes = {
  data: PropTypes.shape({
    pathsByTag: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  loading: PropTypes.bool.isRequired,
  handleSideNav: PropTypes.func.isRequired,
};

LeftNavLink.defaultProps = {
  data: {},
};
